// OWN-224: which step-up method succeeded on /verify. Only NO_2FA changes
// behaviour (it doesn't mark the session verified); owner-api derives the
// emailed Auth Mode from its own session claims.
// TODO: OWN-224: SMS_2FA and NO_2FA are only reachable via the password path,
// which is spoofed for QA until the 2FA logic migrates out of htm-gateway and
// into htm-owner-api. Once real, they'll be emitted by the password flow again.
export const AUTH_MODES = {
  PASSKEY: 'Passkey',
  SMS_2FA: 'SMS 2FA',
  NO_2FA: 'No 2FA',
  RECOVERY_CODE: 'Recovery code',
};

// Paths (locale-stripped) that require secondary sign-in before render.
export const PROTECTED_PATHS = {
  SECURITY: '/security',
  BANK_ACCOUNTS: '/user/bankAccounts',
  PAYMENT: '/financial/payment',
};

export const isProtectedPath = pathname => {
  if (!pathname) {return false;}
  const stripped = pathname.replace(/^\/[a-z]{2,3}(?=\/|$)/i, '');
  return Object.values(PROTECTED_PATHS).some(p => stripped === p);
};

// No-2FA owners can still transact on bank/payment (submission stays in pending
// state, matching prod behaviour) but must be blocked from Security & Login.
// TODO: OWN-224: only consumed by the password path today. When the password
// flow lands for real (post-gateway 2FA migration) this gate becomes live again
// — until then it's referenced by the spoofed password branch and still returns
// the correct answer for the eventual real flow.
export const requiresTwoFactor = pathname => {
  const stripped = pathname?.replace(/^\/[a-z]{2,3}(?=\/|$)/i, '');
  return stripped === PROTECTED_PATHS.SECURITY;
};
